export const SettingsConstants = {
    API_COMPONENTS: 'api/settings/components',
    FETCH_COMPONENTS: 'FETCH_COMPONENTS'
}
